var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('property-card',{attrs:{"property":_vm.property},scopedSlots:_vm._u([{key:"topRight",fn:function(){return [_c('save-button',{attrs:{"property":_vm.property}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }